/**
 * CMCD Version 1
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_V1 = 1;
//# sourceMappingURL=CMCD_V1.js.map